module.exports = __webpack_public_path__ + "static/img/wzdb.111de0d6.png";